/* This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at http://mozilla.org/MPL/2.0/. */
import React, { useState } from 'react';
import { CSSTransition } from 'react-transition-group';
/*
 - test import in payments server
 - translations will need to wait until after settings work is underway,
then we should be able to use the same fluent syntax in content and
payment servers
*/
export const CreateHandleIframeTask = (callback, evtMessage = 'survey complete') => {
    // https://github.com/mozilla/fxa/blob/26224fe8a315d8e9949a577485f9184f47e978c7/packages/fxa-payments-server/src/routes/Product/SubscriptionRedirect/index.tsx#L34
    const handleIframeTask = (evt) => {
        // Note: This event is implemented in code within the SurveyGizmo iframe embed.
        // https://help.surveygizmo.com/help/adding-javascript-to-your-survey
        if (evt.data === evtMessage)
            callback();
    };
    return handleIframeTask;
};
export const Survey = ({ surveyURL, surveyComplete = false }) => {
    const [inProp, setInProp] = useState(false);
    const emoji = `✅ 👍 💖`;
    const surveyCompleteElement = (React.createElement("div", { className: "survey-complete-msg", "data-testid": "survey-complete-msg" },
        React.createElement("p", { className: "emoji" }, emoji),
        React.createElement("p", null, "Thank you for your input."),
        React.createElement("p", { className: "small" }, "This survey will close automatically.")));
    const iframe = (React.createElement("iframe", { className: "survey-iframe", src: surveyURL, frameBorder: "0", onLoad: () => setInProp(true), width: "320", height: "360", "data-testid": "survey-iframe" }));
    return (React.createElement(CSSTransition, { in: inProp, timeout: 200, classNames: "survey-inner" },
        React.createElement("section", { className: "survey-component", "data-testid": "survey-component", "aria-hidden": "true" },
            React.createElement(CSSTransition, { in: inProp, timeout: 100, classNames: "button-inner" },
                React.createElement("button", { className: "survey-control", onClick: () => setInProp(!inProp) })),
            surveyComplete ? surveyCompleteElement : iframe)));
};
export default Survey;
//# sourceMappingURL=index.js.map